import { App } from "vue";
import TabIndex from "./directives/tab-index";

export default {
    install: (app: App) => {
        app.directive("tab-index", TabIndex);
    },
};
